// ═══════════════════════════════════════════════════════════
// Table Keys — 104 tables provisioned 2026-04-22
// ═══════════════════════════════════════════════════════════

export const TABLES = {
  // Core (5)
  incidents: 'mwudh5hnl',
  activityLog: 'zahd9sea5',
  roles: 'rmndfv9l2',
  userRoles: '4g9m6mxlr',
  appSettings: 'ukgreuy4h',

  // PA Grants (24)
  paOrganizations: 'js3hlap9h',
  paDisasters: 'ux80bl4en',
  paProjects: 'r6szawvdp',
  paProjectCosts: '7icbbak5j',
  paReimbursementRequests: 'pyfz5i2co',
  paTimeExtensions: '7w9s694gg',
  paDocuments: 'a8njp0fuu',
  paDamageInventory: '3xc64rl89',
  paInsurance: 'colswj9rx',
  paNotes: '2x12g9lj3',
  paForceAccountEquipment: '0159ly3co',
  paMaterials: 'r6isuzk80',
  paContracts: 'tjjlondcd',
  paRentedEquipment: 'l48fqulze',
  paDonatedResources: '7qyuq4q9k',
  paCompliance: 'ed8i5uj81',
  paTimelineEvents: 'edmil0dt9',
  paChecklistTemplates: 'ouh319s5o',
  paMitigationProposals: 'h06ghcq4t',

  // Debris (15)
  debrisZones: 'sp5cg7l7t',
  debrisContractors: 'k5do08b7u',
  debrisTrucks: 'vgx9z3ybf',
  debrisLoadTickets: 'lwrqc9q33',
  debrisDisposalSites: '7ogwy5s4w',
  debrisMonitors: '7nxb6holr',
  debrisRateSchedules: '4ve40rwtj',
  debrisRightOfEntry: 'jt9akym7h',
  debrisInvoices: 'rqg70n3dt',
  debrisCrews: 'x5w7md26n',
  debrisPhotos: '82pa5silk',
  debrisDocuments: '1aejyiud8',

  // GeoOps + Data Sources (4)
  geoOpsZones: 'ey3i2ncvn',
  cameraSources: '42bjy7efj',
  gisDataSources: 'n5iqr09y8',
  gisFeatures: 's9i1tramo',

  // Shelter (12)
  shelters: '8b935506f',
  survivors: 'udibgvtuy',
  shelterFamilies: '4wdd67usd',
  shelterPets: 'wsepg8nmc',
  shelterMedicalLog: '2omeyb2kb',
  shelterTransfers: 'kwlm2v8a6',
  shelterReunification: 'njtbn2vsg',
  shelterFacilityLibrary: 'zl66mwpjm',
  shelterVehicles: '4drail33y',
  shelterIncidents: '8i9pqjsio',
  shelterReferrals: 'hbkm6lhq2',
  shelterSupplies: 'wx1fv17bd',

  // Impact (4)
  impactAssessments: 'h2rnhci4m',
  impactPhotos: 'cr3cmaoal',
  impactDetails: 'ggsxii0kn',
  impactSelfReports: 'gpk5vbyp9',

  // Intake (2)
  individuals: '7fgeepu9i',
  propertyItems: 'y593l964s',

  // Time & Labor (2)
  laborEmployees: '0ksxsvsh3',
  forceAccountLabor: 'votjxg8dw',

  // HotWash (2)
  observations: 'nsjo6xyee',
  aiInsights: '3uee5ogv7',

  // Handoff (4)
  handoffEvents: 'ztevlvxfz',
  handoffPositions: 'pqdy22ept',
  handoffNotes: 'tonw0y1io',
  handoffActionItems: '1cpypfiub',

  // RollCall (3)
  rcPersonnel: 'grtip7yxj',
  rcEvents: 'zqarpc156',
  rcCheckins: '0kcnmszg2',

  // Battle Rhythm (3)
  brMeta: 'nf1ig80lk',
  brEvents: '4ustywpyq',
  brTemplates: 'qmnubxr5k',

  // PACE (6)
  paceProfiles: '3umd7oeeg',
  pacePlans: 'mx3dca2uu',
  pacePlanEntries: 'mf86zqkwx',
  callDowns: '240wwzuhl',
  callDownResponses: 'qofsdc5xu',
  callDownTemplates: 'pq38kig0k',

  // Volunteer (3)
  volunteers: 'onf0kz369',
  volunteerEvents: '9mxdlpo8k',
  volunteerAssignments: 'ks4ofz9p0',

  // Blackboard (6)
  bbTrainings: 'z7d9lhw84',
  bbTrainingRecords: 'tvyx5qg9b',
  bbClassrooms: '2au9clwps',
  bbCertificates: '6tkntcevo',
  bbPositionPlans: 'lcvdr8zs4',
  bbMessages: 'fu2coiv5z',

  // MainStreet (10)
  msOrganizations: 'e6l3v5sno',
  msContacts: 'evky1hlzy',
  msFacilities: '9fxxmwy0f',
  msDamageReports: 'u9fn61j4x',
  msResourceOffers: 'e0nirncei',
  msStatusChecks: 'ka4ust0aj',
  msStatusResponses: 'oagfqqbr6',
  msReentryAuthorizations: 'y2ewk0rhf',
  msReentryPasses: 'p6z3djycp',
  msOrgLists: '5xlymaork',

  // File Library (2)
  flDocuments: 'b8t29jus6',
  flCategories: '1snehhl88',

  // Workflows (3)
  workflowTemplates: '0b63zf0vo',
  workflowInstances: 'sx6de7xon',
  workflowSteps: 'l9iowy2d9',

  // Forms (2)
  formTemplates: '05n7o1hzw',
  formResponses: 'uqt1oe3xx',
} as const;
